
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7xxJX", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $7bDsi = parcelRequire("7bDsi");


var $dIxHZ = parcelRequire("dIxHZ");


var $aXWIB = parcelRequire("aXWIB");


var $bBvs5 = parcelRequire("bBvs5");


var $brT61 = parcelRequire("brT61");


var $4wbMW = parcelRequire("4wbMW");

const $3cdbdb59fe99fb22$var$Date = /*#__PURE__*/ (0, $42omo.memo)(function Date(props) {
    const inlineAnnotationProps = (0, $4wbMW.useInlineAnnotationProps)(props);
    const { timestamp: timestamp, parentIsIncompleteTask: parentIsIncompleteTask, intl: intl } = props;
    const { timeZone: timeZone } = (0, $bBvs5.useRendererContext)();
    const className = !!parentIsIncompleteTask && (0, $dIxHZ.isPastDate)(timestamp, timeZone) ? 'date-node date-node-highlighted' : 'date-node';
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7bDsi.DateSharedCssClassName).DATE_WRAPPER,
        ...inlineAnnotationProps,
        children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-node-type": "date",
            "data-timestamp": timestamp,
            children: parentIsIncompleteTask ? (0, $dIxHZ.timestampToTaskContext)(timestamp, intl, timeZone) : (0, $dIxHZ.timestampToString)(timestamp, intl)
        })
    });
});
const $3cdbdb59fe99fb22$export$19285a5b05c4ea7c = (0, $aXWIB.injectIntl)($3cdbdb59fe99fb22$var$Date);
function $3cdbdb59fe99fb22$var$DateWithFormatContext(props) {
    const [isChecked] = (0, $brT61.useTaskItemsFormatContext)();
    let parentIsIncompleteTask = props.parentIsIncompleteTask;
    if (typeof isChecked !== 'undefined') parentIsIncompleteTask = !isChecked;
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $l998X.jsx)($3cdbdb59fe99fb22$export$19285a5b05c4ea7c, {
        ...props,
        parentIsIncompleteTask: parentIsIncompleteTask
    });
}
var $3cdbdb59fe99fb22$export$2e2bcd8739ae039 = $3cdbdb59fe99fb22$var$DateWithFormatContext;
module.exports["default"] = $3cdbdb59fe99fb22$export$2e2bcd8739ae039;

});

parcelRegister("brT61", function(module, exports) {
/* eslint-disable jsdoc/require-jsdoc */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $d33001fc1b36b5a2$var$defaultValue = [
    undefined,
    ()=>{}
];
const $d33001fc1b36b5a2$var$TaskItemsFormatContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($d33001fc1b36b5a2$var$defaultValue);
const $d33001fc1b36b5a2$var$reducer = (_state, action)=>{
    return action;
};
function $d33001fc1b36b5a2$export$1ca88acfa8fef6b0({ children: children }) {
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useReducer($d33001fc1b36b5a2$var$reducer, undefined);
    return /*#__PURE__*/ (0, $l998X.jsx)($d33001fc1b36b5a2$var$TaskItemsFormatContext.Provider, {
        value: value,
        children: children
    });
}
function $d33001fc1b36b5a2$export$617439880b48c653() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($d33001fc1b36b5a2$var$TaskItemsFormatContext);
}
function $d33001fc1b36b5a2$export$be32c078f3ebeea0({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)($d33001fc1b36b5a2$var$TaskItemsFormatContext.Consumer, {
        children: children
    });
}
module.exports["TaskItemsFormatProvider"] = $d33001fc1b36b5a2$export$1ca88acfa8fef6b0;
module.exports["useTaskItemsFormatContext"] = $d33001fc1b36b5a2$export$617439880b48c653;
module.exports["TaskItemsFormatConsumer"] = $d33001fc1b36b5a2$export$be32c078f3ebeea0;

});

parcelRegister("4wbMW", function(module, exports) {
/* eslint-disable jsdoc/require-jsdoc */ 
var $dh538 = parcelRequire("dh538");


var $3h7Ko = parcelRequire("3h7Ko");

function $f39f21f184303967$export$11564cda945bb3c9(props) {
    const { selectionDraftDocumentPosition: draftPosition } = (0, $3h7Ko.useAnnotationRangeState)();
    if (!(0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) return {};
    if (!props.dataAttributes) // the inlineCard component is currently used by the block card, embed card and card error boundary components
    // when used via these components, no dataAttributes are passed (and we don't want it setup for inline comments)
    return {};
    const inlineCardPosition = props.dataAttributes['data-renderer-start-pos'] - 1;
    const hasDraft = draftPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.from <= inlineCardPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.to >= inlineCardPosition + 1;
    if (hasDraft) return {
        'data-renderer-mark': true,
        'data-annotation-draft-mark': true,
        'data-annotation-inline-node': true,
        'data-renderer-start-pos': inlineCardPosition
    };
    return {
        'data-annotation-inline-node': true,
        'data-annotation-mark': true,
        'data-renderer-start-pos': inlineCardPosition
    };
}
module.exports["useInlineAnnotationProps"] = $f39f21f184303967$export$11564cda945bb3c9;

});

parcelRegister("dlSEv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b87a15bb5e36b12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $9b87a15bb5e36b12$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});


//# sourceMappingURL=date.455e3cf6.js.map
